import { render, staticRenderFns } from "./TechnicalSpecificationStraps.vue?vue&type=template&id=a52ca984&scoped=true&"
import script from "./TechnicalSpecificationStraps.vue?vue&type=script&lang=js&"
export * from "./TechnicalSpecificationStraps.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSpecificationStraps.vue?vue&type=style&index=0&id=a52ca984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52ca984",
  null
  
)

export default component.exports